<template>
	<div class="adDelete">
		<div class="title">{{ title }}</div>
		<div>
			<el-form :model="obj" ref="ruleForm" label-width="120px">
				<el-form-item
					v-for="(item, key, index) in obj"
					:key="index"
					:rules="rules.content"
					:label="`${label}${index + 1}`"
					:prop="key"
				>
					<el-input style="width: 82%" v-model="obj[key]" @input="input"></el-input>
					<div class="inputFilter">
						{{ obj[key] | inputFilter(that.ispromotion) }}/{{ maxlength }}
					</div>
					<i
						@click="removeArr(index)"
						v-if="list.length > minquantity + 1"
						class="el-icon-remove-outline circleIcon"
					></i>
					<i
						@click="addArr()"
						v-if="index == list.length - 1"
						class="el-icon-circle-plus-outline circleIcon"
					></i>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>
<script>
import { bracketMatch } from '@/common/util.js';
export default {
	props: {
		title: null,
		Arr: null,
		maxquantity: {
			type: Number,
		},
		minquantity: {
			type: Number,
		},
		label: null,
		maxlength: {
			type: Number,
		},
		ispromotion: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			that: this,
			rules: {},
			obj: {},
		};
	},
	filters: {
		inputFilter(value, ispromotion) {
			let temp = 0;
			let reg = /{(keyword:|KeyWord:|Keyword:).+?}/g;
			let matchValue = value.match(reg);
			if (ispromotion && matchValue && matchValue.length) {
				matchValue.forEach(element => {
					let str = element.substr(9);
					str = str.slice(0, str.length - 1);
					value = value.replace(element, '') + str;
				});
			}
			if (value && value.length) {
				for (let i = 0; i < value.length; i++) {
					if (/[^\x00-\xff]/.test(value[i])) {
						temp += 2;
					} else {
						temp++;
					}
				}
			}
			return temp;
		},
	},
	methods: {
		addArr() {
			if (Object.keys(this.Arr).length < this.maxquantity) {
				this.list.push({ content: '' });
				this.changeList(this.list);
			}
		},
		removeArr(index) {
			this.list.splice(index, 1);
			this.changeList(this.list);
		},
		input() {
			this.changeList(this.list)
		},
		changeList(val) {
			let obj1 = val.map(function (item, index) {
				return JSON.parse(JSON.stringify(item).replace(/content/g, `content${index + 1}`));
			});
			let a1 = obj1.reduce((acc, value) => {
				return { ...acc, ...value };
			});

			this.validate(this.callback);
			this.$emit('getList', a1);
		},
		validate(callback) {
			this.$refs['ruleForm'].validate(valid => {
				if (valid) {
					callback(valid);
				} else {
					callback(false);
					return false;
				}
			});
		},
		callback(valids) {
			if (valids) {
				if(this.title == '广告标题') {
					this.$emit('getValidateTit', true);
				}else {
					this.$emit('getValidateInfo', true);
				}
			} else {
				if(this.title == '广告标题') {
					this.$emit('getValidateTit', false);
				}else {
					this.$emit('getValidateInfo', false);
				}
			}
		}
	},
	watch: {
		Arr: {
			handler(val) {
				this.obj = val;
				this.$refs.ruleForm && this.validate(this.callback)
			},
			immediate: true,
      deep: true,
		},
	},
	computed: {
		list() {
			return Object.values(this.obj).map(item => ({ content: item }));
		},
	},
	created() {
		let validateContent = (rule, value, callback) => {
			function countOccurrences(arr, target) {
				var num = arr.reduce(function (acc, cur) {
					return cur === target ? acc + 1 : acc + 0;
				}, 0);
				return num;
			}
			if (countOccurrences(Object.values(this.Arr), value) !== 1) {
				callback(new Error('内容不能重复'));
			} else {
				callback();
			}
		};
		let validataLength = (rule, value, callback) => {
			function lengthOccurrences(txt) {
				let temp = 0;
				for (let i = 0; i < txt.length; i++) {
					if (/[^\x00-\xff]/.test(txt[i])) {
						temp += 2;
					} else {
						temp++;
					}
				}
				return temp;
			}

			if (lengthOccurrences(value) > this.maxlength) {
				callback(new Error(`字符限制为${this.maxlength}个字符`));
			} else {
				callback();
			}
		};
		let keyWordValidator = (rule, value, callback) => {
			let val = value;
			let flag = true;
			let regFirst = /{/g;
			let regbrackets = /{.+?}/g;
			let reg = /{(keyword:|KeyWord:|Keyword:).+?}/g;
			let temp = 0;
			let matchValue = value.match(reg);
			if (bracketMatch(value)) {
				flag = value.match(regbrackets)?.every(ele => {
					reg.lastIndex = 0;
					return reg.test(ele);
				});
			}
			if (matchValue && matchValue.length) {
				matchValue.forEach(element => {
					let str = element.substr(9);
					str = str.slice(0, str.length - 1);
					val = val.replace(element, '') + str;
				});
			}
			if (val && val.length) {
				for (let i = 0; i < val.length; i++) {
					// if (/[\u4e00-\u9fa5]/.test(val[i])) {
					if (/[^\x00-\xff]/.test(val[i])) {
						temp += 2;
					} else {
						temp++;
					}
				}
			}
			let reg1=/,(?!\s)\b/g;
			//先判断{}是不是成双的
			//取出所有的{}遍历格式是否正确
			if (regFirst.test(value) && (!bracketMatch(value) || !flag)) {
				callback(new Error('插入关键词语法错误'));
			} else if (temp > this.maxlength) {
				callback(new Error(`字符限制为${this.maxlength}个字符`));
			} else if(reg1.test(value))
            {
                callback(new Error("不可接受的间距"));
            } else {
				callback();
			}
		};
		if (this.ispromotion) {
			this.rules = {
				content: [
					{ required: true, message: '内容不能为空', trigger: 'blur' },
					{ validator: validateContent, trigger: 'blur' },
					{ validator: keyWordValidator, trigger: 'blur' },
				],
			};
		} else {
			this.rules = {
				content: [
					{ required: true, message: '内容不能为空', trigger: 'blur' },
					{ validator: validataLength, trigger: 'blur' },
				],
			};
		}
	},
};
</script>
<style lang="scss" scoped>
.adDelete {
	.title {
		font-size: 14px;
		margin-bottom: 20px;
	}
}
.inputFilter {
	width: 32px;
	margin-left: 5px;
	display: inline-block;
	font-size: 12px;
	color: #999999;
	text-align: right;
}
.circleIcon {
	margin-left: 5px;
	cursor: pointer;
	color: #3da1ff;
}
</style>
